<template>
  <div class="container">
    <div v-if="!isAdmin" class="content" v-html="content"></div>
    <editor
      v-if="isAdmin"
      ref="editor"
      :value="content"
      showUser
      showArticle
      @on-change="handleEditorChange"
      style="width: 100%;height: 760px;"
    />
    <div v-if="isAdmin" class="btn-box">
      <Button type="primary" :disabled="loading" :loading="loading" @click="handleSave">保存</Button>
    </div>
  </div>
</template>

<script>
import Editor from "_c/editor";
export default {
  name: "author_note",
  components: {
    Editor,
  },
  data() {
    return {
      loading: false,
      isAdmin: Number(localStorage.getItem("sa")),
      modalVisibile: false,
      content: "",
      id: "",
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    handleCancel() {
      this.modalVisibile = false;
    },
    getTableData() {
      if (this.isAdmin) {
        this.$refs.editor.setHtml("");
      }
      this.$api.getAuthorNotes({}).then((res) => {
        if (res.code === 0) {
          if (this.isAdmin) {
            this.$refs.editor.setHtml(res.data.notes_content);
          }
          this.content = res.data.notes_content;
          this.id = res.data.id;
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    handleSave() {
      this.loading = true;
      this.$api
        .editAuthorNotes({ id: this.id, notes_content: this.content })
        .then((res) => {
          this.loading = false;
          this.$Message.success("保存成功");
        });
    },
    handleEditorChange(val) {
      this.content = val;
    },
  },
};
</script>

<style scoped lang="less">
.btn-box {
  text-align: center;
}
/deep/ .editor-wrapper {
  .w-e-text-container {
    height: 700px !important;
  }
}
.container {
  height: calc(100vh - 200px);
}
</style>
